export default __webpack_public_path__ + "static/media/mixed-card.da888537.png";